import script from "./UserProfileModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfileModal.vue?vue&type=script&setup=true&lang=js"

import "./UserProfileModal.vue?vue&type=style&index=0&id=2f90b5d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f90b5d4"]])

export default __exports__